// ** MUI Imports
import { Theme } from '@mui/material/styles'

const input = (theme: Theme) => {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          lineHeight: '1.5rem',
          '&:before': {
            borderBottom: `1px solid ${theme.palette.customColors.main.replace(')', ', 0.22)')}`
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: `1px solid ${theme.palette.customColors.main.replace(')', ', 0.32)')}`
          },
          '&.Mui-disabled:before': {
            borderBottomStyle: 'solid'
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: 2,
          borderTopRightRadius: 2,
          backgroundColor: theme.palette.customColors.main.replace(')', ', 0.05)'),
          '&:hover:not(.Mui-disabled)': {
            backgroundColor: theme.palette.customColors.main.replace(')', ', 0.08)')
          },
          '&:before': {
            borderBottom: `1px solid ${theme.palette.customColors.main.replace(')', ', 0.22)')}`
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: `1px solid ${theme.palette.customColors.main.replace(')', ', 0.32)')}`
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.customColors.main.replace(')', ', 0.05)'),
            '&:before': {
              borderBottomStyle: 'solid'
            }
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 5,
          '&:hover:not(.Mui-focused):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.customColors.main.replace(')', ', 0.32)')
          },
          '&:hover.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.customColors.main.replace(')', ', 0.22)')
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.text.disabled
          }
        }
      }
    }
  }
}

export default input
